import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { ProductionScheduleCalendar } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductionScheduleCalendarService extends TmsWebBaseEditService<
  ProductionScheduleCalendar,
  ProductionScheduleCalendar
> {
  constructor() {
    super('ProductionScheduleCalendar', $localize`Schedule Calendar`);
  }
}
